import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-add-field',
  templateUrl: './add-field.component.html',
  styleUrls: ['./add-field.component.scss']
})
export class AddFieldComponent implements OnInit {
  form!: FormGroup;
  type: any;
  category: string = '';
  isInventorySubtype: boolean = false;

  constructor(
    private mDatabase: AngularFireDatabase,
    private mSnackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddFieldComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // ✅ Handle both string and object data
    if (typeof data === 'string') {
      this.type = data;
      this.isInventorySubtype = false;
    } else if (typeof data === 'object') {
      this.type = data.type;
      this.category = data.category || '';
      this.isInventorySubtype = !!data.category; // ✅ If category exists, it's inventory subtype
    }
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
    });
  }

  get Name() {
    return this.form?.get('name');
  }

  Submit() {
    if (!this.form.valid) {
      this.mSnackBar.open('Please fill in all required fields', '', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
      return;
    }

    const newValue = this.Name?.value?.trim();

    if (!newValue) {
      this.mSnackBar.open('Name cannot be empty', '', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
      return;
    }

    // ✅ Determine the correct path based on whether it's inventory subtype or regular type
    if (this.isInventorySubtype && this.category) {
      // Save to inventory_subtypes/{category}
      this.saveToInventorySubtypes(newValue);
    } else {
      // Save to types/{type}
      this.saveToTypes(newValue);
    }
  }

  /**
   * Save to inventory_subtypes/{category}
   */
  private saveToInventorySubtypes(value: string): void {
    const path = `inventory_subtypes/${this.category}`;
    const ref = this.mDatabase.database.ref(path);

    ref.push(value)
      .then(() => {
        this.mSnackBar.open('Sub-category added successfully', '', {
          duration: 3000,
          panelClass: ['success-snackbar']
        });
        this.dialogRef.close(true);
      })
      .catch((error) => {
        console.error('Error adding subcategory:', error);
        this.mSnackBar.open('Failed to add sub-category', '', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
      });
  }

  /**
   * Save to types/{type}
   */
  private saveToTypes(value: string): void {
    const path = `types/${this.type}`;
    const key = this.mDatabase.database.ref(path).push().key;

    if (!key) {
      this.mSnackBar.open('Failed to generate key', '', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
      return;
    }

    this.mDatabase.object(`${path}/${key}`)
      .set(value)
      .then(() => {
        this.mSnackBar.open(`${this.type} added successfully`, '', {
          duration: 3000,
          panelClass: ['success-snackbar']
        });
        this.dialogRef.close(true);
      })
      .catch((error) => {
        console.error('Error adding type:', error);
        this.mSnackBar.open('Failed to add type', '', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
      });
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}


